/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgApplicationSuite = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11.553 3.106a1 1 0 0 1 .894 0l4 2a1.077 1.077 0 0 1 .202.133.95.95 0 0 1 .199.227l.01.019a.634.634 0 0 1 .06.116l.013.03A1.05 1.05 0 0 1 17 6l-.004-.086.003.054L17 6v3.382l3.447 1.724a1.077 1.077 0 0 1 .202.133.95.95 0 0 1 .199.227l.01.019a.634.634 0 0 1 .06.116l.013.03A1.05 1.05 0 0 1 21 12l-.004-.091c.002.02.003.039.003.059L21 12v4a1 1 0 0 1-.553.894l-8 4a1.05 1.05 0 0 1-.35.103 1.178 1.178 0 0 1-.195 0 .936.936 0 0 1-.217-.047 1.036 1.036 0 0 1-.132-.056l.074.034a1.013 1.013 0 0 1-.036-.015l-.038-.019-8-4A1 1 0 0 1 3 16v-4a1.055 1.055 0 0 1 .07-.37.68.68 0 0 1 .039-.086.71.71 0 0 1 .031-.06.942.942 0 0 1 .298-.313.964.964 0 0 1 .115-.065l-.09.05.072-.042.018-.008L7 9.38V6a1.055 1.055 0 0 1 .07-.37.68.68 0 0 1 .039-.086.71.71 0 0 1 .031-.06.942.942 0 0 1 .298-.313.964.964 0 0 1 .115-.065l-.09.05.072-.042.018-.008zM9 15.618v1.764l2 1v-1.764zm6 0-2 1v1.763l2-1zm-10-2v1.764l2 1v-1.764zm14 0-2 1v1.763l2-1zm-7.001-.5-1.762.881 1.763.882L13.763 14l-.765-.383zm-4-2-1.763.881L8 12.881 9.763 12zm8.001 0-1.763.881 1.763.882L17.763 12zm-7-3.5v1.764l2 1V8.618zm6 0-2 1v1.763l2-1zm-3-2.5-1.764.881L12 6.881 13.763 6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgApplicationSuite as ApplicationSuite };
